import { ThemeProvider } from 'next-themes'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { autopairFromUrl } from './lib/bridge/autopair'
import './styles/globals.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found')

// Pair from the launch URL (token/title) BEFORE mounting, so the first key read
// already sees the token and the config screen prefills the title (PRD 007).
autopairFromUrl().finally(() => {
  createRoot(root).render(
    <StrictMode>
      <ThemeProvider
        attribute="data-theme"
        defaultTheme="system"
        enableSystem
        storageKey="convariance.theme"
        disableTransitionOnChange
      >
        <App />
      </ThemeProvider>
    </StrictMode>
  )
})
